import React, { ChangeEvent } from 'react';
import { Form } from 'react-bootstrap';
import {
  Control,
  Controller,
  FieldValues,
  UseFormRegister,
} from 'react-hook-form';
import { InputContainer } from '../styles';
import InputMask from 'react-input-mask';

interface InputMaskProps {
  label?: string;
  name: string;
  isError: boolean;
  alwaysShowMask?: boolean;
  control: Control<FieldValues, any>;
}

export const InputMaskIe: React.FC<InputMaskProps> = ({
  label = '',
  name,
  isError,
  alwaysShowMask = false,
  control,
  ...rest
}) => {
  return (
    <>
      <InputContainer>
        <Form.Group>
          <Form.Label>{label}</Form.Label>
          <Controller
            name={name}
            control={control}
            render={({ field: { value, onChange, onBlur, ref } }) => {
              return (
                <InputMask
                  mask="999.999.999.999"
                  alwaysShowMask={alwaysShowMask}
                  maskPlaceholder="000.000.000.000"
                  placeholder="000.000.000.000"
                  onChange={onChange}
                  onBlur={onBlur}
                  value={value || ''}
                  className={
                    isError ? 'form-control is-invalid' : 'form-control'
                  }
                  {...rest}
                >
                  {(inputProps: any) => {
                    return (
                      <input
                        {...inputProps}
                        name={name}
                        type="text"
                        ref={ref}
                      />
                    );
                  }}
                </InputMask>
              );
            }}
          />
        </Form.Group>
      </InputContainer>
    </>
  );
};
